<h2 mat-dialog-title id="confirm-popup-header">{{ data.title || 'Confirm action' }}</h2>

<mat-dialog-content>
  <p style="white-space: pre-line">{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end" id="confirm-popup-actions">
  <button class="btn btn-secondary" (click)="onCancel()">
    {{ data.cancelText || 'Cancel' }}
  </button>
  <button class="btn btn-primary" (click)="onConfirm()">
    {{ data.confirmText || 'OK' }}
  </button>
</mat-dialog-actions>
